import { Check } from "lucide-react";
import { TrialForm } from "@/components/TrialForm";
import { Reveal } from "@/components/Reveal";

const PERKS = [
    "A full live lesson with a real teacher — not a recording",
    "Mapped to your child's year group and school curriculum",
    "Honest feedback and a suggested learning plan afterwards",
    "No card details, no contract, no obligation",
];

export default function FreeTrial() {
    return (
        <main className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24" data-testid="free-trial-page">
            <div className="grid items-start gap-14 lg:grid-cols-2">
                <Reveal>
                    <p className="text-xs font-medium uppercase tracking-[0.28em] text-saffron">Free Trial Lesson</p>
                    <h1 className="mt-4 font-serif text-4xl font-semibold leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl">
                        Try a lesson. <em className="italic text-saffron">On us.</em>
                    </h1>
                    <p className="mt-6 max-w-lg text-base leading-relaxed text-muted-foreground md:text-lg">
                        Tell us about your child and we'll match them with the right teacher for a completely free,
                        no-obligation trial lesson — at a time that suits your family, in your time zone.
                    </p>
                    <ul className="mt-9 space-y-4" data-testid="trial-perks-list">
                        {PERKS.map((p) => (
                            <li key={p} className="flex items-start gap-3 text-sm leading-relaxed text-ink/85 md:text-base">
                                <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-saffron-soft">
                                    <Check className="h-3.5 w-3.5 text-saffron-dark" />
                                </span>
                                {p}
                            </li>
                        ))}
                    </ul>
                    <p className="mt-10 border-l-2 border-saffron pl-5 font-serif text-lg italic leading-relaxed text-teal">
                        "The trial lesson alone told us more about our son's maths gaps than a whole school term."
                        <span className="mt-2 block font-sans text-xs not-italic uppercase tracking-[0.16em] text-muted-foreground">
                            — Parent, Toronto
                        </span>
                    </p>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="rounded-3xl border border-border bg-sand p-8 card-shadow lg:p-10">
                        <h2 className="font-serif text-2xl font-semibold tracking-tight text-ink">Book your free lesson</h2>
                        <p className="mt-2 text-sm text-muted-foreground">Takes under a minute. We reply within 24 hours.</p>
                        <div className="mt-8">
                            <TrialForm />
                        </div>
                    </div>
                </Reveal>
            </div>
        </main>
    );
}
